import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from '../util/animation/fade/fade';

interface SlugRefs {
  elementRef: RefObject<HTMLDivElement | null>;
  skipWipeIn: boolean;
  skipWipeOut: () => boolean;
  hasFadeTransition: () => boolean;
  scrollWrapperRef: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { skipWipeIn, scrollWrapperRef, hasFadeTransition }: SlugRefs,
): void {
  if (hasFadeTransition() && scrollWrapperRef.current) {
    timeline.add(fadeFromTo(scrollWrapperRef.current, { duration: 0.2 }));
  } else if (!skipWipeIn && scrollWrapperRef?.current) {
    timeline.fromTo(
      scrollWrapperRef.current,
      { y: 300 },
      { duration: 0.5, y: 0, ease: 'Quad.easeIn' },
      0,
    );
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, skipWipeOut, hasFadeTransition }: SlugRefs,
): void {
  if (hasFadeTransition() && elementRef?.current) {
    timeline.add(fadeTo(elementRef.current, { duration: 0.2 }));
  } else if (!skipWipeOut() && elementRef?.current) {
    timeline.to(elementRef.current, { duration: 0.5, y: -300, ease: 'Quad.easeOut' }, 0);
    // Add 100ms extra time before changing page, to avoid a lot of processing during/after transition

    timeline.add(() => {}, '+=0.1');
  } else {
    timeline.to(elementRef.current, { opacity: 1, duration: 0.001 });
  }
}
